var millisecondsInSecond = 1000;
var secondsInMinute = 60;
/** Might be migrated to configuration. ఠ_ఠ */
var fiveMinutes = 5;
/** Token validation time interval */
export var tokenValidationInterval = fiveMinutes * secondsInMinute * millisecondsInSecond;
